export const environment = {
  name: 'prod',
  apiUrl: 'https://trueface.co.in',
  production: true
};